<template>
  <div>
    <vs-popup
      :active.sync="infoModal.active"
      title="รายละเอียด"
      class="custom-popup"
    >
      <div class="mb-5">
        <p v-html="infoModal.text"></p>
      </div>
    </vs-popup>

    <vx-card>
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
          <vs-divider position="left" class="text-2xl">{{ $t('sections.prosecution.dataForm.title.normal') }}</vs-divider>
          <div class="vx-row flex">
            <div class="vx-col flex-1">
              <validation-provider :name="$t('sections.prosecution.dataForm.caseDate')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{$t('sections.prosecution.dataForm.caseDate')}}*</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.caseDate"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1">
              <validation-provider :name="$t('sections.prosecution.dataForm.caseNumber')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.caseNumber") }}* <a class="cursor-pointer" @click="onPressedActiveInfoModal('caseNumber')"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                <vs-input type="text" class="w-full" v-model="form.caseNumber" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1">
              <validation-provider :name="$t('sections.prosecution.dataForm.lawyer')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.lawyer") }}* </label>
                <v-select v-model="form.lawyer" :clearable="true" :options="lawyerOptions" name="lawyer" :reduce="res => res.value" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col flex-1">
              <validation-provider :name="$t('sections.prosecution.dataForm.borrower')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.borrower") }}*</label>
                <v-select v-model="form.borrower" :clearable="true" :options="borrowerOptions" name="borrowers" :reduce="res => res.value"   />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1">
              <validation-provider :name="$t('sections.prosecution.dataForm.contract')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.contract") }}* <a class="cursor-pointer" @click="onPressedActiveInfoModal('contract')"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                <v-select v-model="form.contract" :clearable="true" :options="contractOptions" name="contract" :reduce="res => res.value" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 ">
              <validation-provider :name="$t('sections.prosecution.dataForm.sureties')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.sureties") }}</label>
                <v-select v-model="form.sureties" :clearable="true" :options="suretyOptions" name="sureties" :reduce="res => res.value" multiple/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col flex-1 ">
              <validation-provider :name="$t('sections.prosecution.dataForm.contractDate')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.contractDate") }}*</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.contractDate" :disabled="true"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 ">
              <validation-provider :name="$t('sections.prosecution.dataForm.curriculumName')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.curriculumName") }}*</label>
                <vs-input type="text" class="w-full" v-model="form.curriculumName" disabled="disabled" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 ">
              <validation-provider :name="$t('sections.prosecution.dataForm.firstMissedAppointmentDate')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.firstMissedAppointmentDate") }}</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.firstMissedAppointmentDate" :disabled="true"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col w-1/3 ">
              <validation-provider :name="$t('sections.prosecution.dataForm.firstCollectionFeeLetterDate')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.firstCollectionFeeLetterDate") }} <a class="cursor-pointer" @click="onPressedActiveInfoModal('firstCollectionFeeLetterDate')"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.firstCollectionFeeLetterDate"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/3 ">
              <validation-provider :name="$t('sections.prosecution.dataForm.sendCollectionFeeLetterCount')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.prosecution.dataForm.sendCollectionFeeLetterCount") }} <a class="cursor-pointer" @click="onPressedActiveInfoModal('sendCollectionFeeLetterCount')"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                <vs-input type="number" class="w-full" v-model="form.sendCollectionFeeLetterCount" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <vs-divider position="left" class="text-2xl">{{ $t('sections.prosecution.dataForm.title.asset') }} <a class="cursor-pointer" @click="onPressedActiveInfoModal('titleAsset')"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></vs-divider>
          <div class="vx-row flex">
            <div class="vx-col w-1/4">
              <validation-provider :name="$t('sections.prosecution.dataForm.dateOfBalanceExtraction')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{$t('sections.prosecution.dataForm.dateOfBalanceExtraction')}}* <a class="cursor-pointer" @click="onPressedActiveInfoModal('dateOfBalanceExtraction')"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                <div class="flex items-center relative">
                  <flat-pickr
                    :config="configDatePicker"
                    class="w-full pr-10"
                    v-model="form.dateOfBalanceExtraction"
                  />
                  <vs-button
                    v-if="form.dateOfBalanceExtraction"
                    @click="form.dateOfBalanceExtraction = null"
                    class="ml-2 bg-danger"
                  >
                    ✕
                  </vs-button>
                </div>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col flex-1">
              <validation-provider :name="$t('sections.prosecution.dataForm.principle')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.principle') }}</label>
                <vs-input type="number" v-model="form.principle" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 ">
              <validation-provider :name="$t('sections.prosecution.dataForm.interest')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.interest') }}</label>
                <vs-input type="number" v-model="form.interest" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 ">
              <validation-provider :name="$t('sections.prosecution.dataForm.penalty')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.penalty') }}</label>
                <vs-input type="number" v-model="form.penalty" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 ">
              <validation-provider :name="$t('sections.prosecution.dataForm.fee')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.fee') }} <a class="cursor-pointer" @click="onPressedActiveInfoModal('fee')"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                <vs-input type="number" v-model="form.fee" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col w-1/4">
              <validation-provider :name="$t('sections.prosecution.dataForm.expenseDetailAmount')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.expenseDetailAmount') }} <a class="cursor-pointer" @click="onPressedActiveInfoModal('expenseDetailAmount')"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                <vs-input type="number" v-model="form.expenseDetailAmount" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4">
              <validation-provider :name="$t('sections.prosecution.dataForm.collectionFee')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.collectionFee') }}</label>
                <vs-input type="number" v-model="form.collectionFee" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4">
              <validation-provider :name="$t('sections.prosecution.dataForm.lawyerFee')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.lawyerFee') }}</label>
                <vs-input type="number" v-model="form.lawyerFee" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/4">
              <validation-provider name="รวม" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">รวม <a class="cursor-pointer" @click="onPressedActiveInfoModal('totalAsset')"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                <vs-input type="number" v-model="totalAsset" class="w-full" disabled="disabled"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="submit">{{ $t("sections.prosecution.dataForm.action.btnSave") }}</vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset">{{ $t("sections.prosecution.dataForm.action.btnReset") }}</vs-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import { createNamespacedHelpers, mapGetters } from 'vuex'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/themes/dark.css';
import {Thai} from "flatpickr/dist/l10n/th";

const { mapActions: mapProsecutionActions, mapState: mapProsecutionFields } = createNamespacedHelpers('Prosecution')
const { mapActions: mapAccountingActions } = createNamespacedHelpers('Accounting')
const { mapActions: mapCustomerActions } = createNamespacedHelpers('Customer');

export default {
  components: {
    vSelect,
    ValidationProvider,
    flatPickr
  },
  data () {
    return {
      infoModal: {
        active: false,
        text: ""
      },
      form:{
        // ข้อมูลทั่วไป
        caseDate: new Date(),
        caseNumber: "",
        lawyer: null,
        borrower: null,
        contract: null,
        sureties: [],
        contractDate: null,
        curriculumName: "",
        firstMissedAppointmentDate: null,
        firstCollectionFeeLetterDate: null,
        sendCollectionFeeLetterCount: 0,
        // ทุนทรัพย์
        dateOfBalanceExtraction: null,
        principle: 0,
        interest: 0,
        penalty: 0,
        fee: 0,
        expenseDetailAmount: 0,
        collectionFee: 0,
        lawyerFee: 0, // ค่าทนาย, ค่าใช้จ่ายในการดำเนินคดี (ที่ระบุไว้ในสัญญา)
      },
      configDatePicker: {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y"
      },
    }
  },
  async created () {
    const vm = this
    vm.$vs.loading();
    await vm.initData();
    await vm.reset();
    setTimeout(() => {
      vm.created = true
      vm.$vs.loading.close();
    }, 500);
    // vm.pms ('ProsecutionTransaction', 'create', 'r')
  },
  computed: {
    ...mapProsecutionFields(['status']),
    ...mapGetters({
      lawyerOptions: "Prosecution/lawyerOptions",
      borrowerOptions: "Customer/borrowerOptions",
      contractOptions: "Accounting/contractOptions",
      suretyOptions: "Customer/suretyOptions",
    }),
    totalAsset: function () {
      return ['principle', 'interest', 'penalty', 'fee', 'expenseDetailAmount', 'collectionFee', 'lawyerFee']
        .map(key => parseFloat(this.form[key]) || 0)
        .reduce((sum, value) => sum + value, 0)
    }
  },
  methods: {
    ...mapProsecutionActions(['getLawyerOptions', 'createProsecution']),
    ...mapAccountingActions(['getContractOptionsForProsecution', 'setContractOptions']),
    ...mapCustomerActions(['getSuretyFilterOptionsForProsecution', 'setSuretyOptions', 'getBorrowerOptions']),
    initData: async function () {
      const vm = this
      const { getLawyerOptions, getBorrowerOptions } = vm
      await getLawyerOptions();
      await getBorrowerOptions();
    },
    reset() {
      const vm = this;
      const { setContractOptions, setSuretyOptions } = vm
      const lawyerChoose = vm.lawyerOptions.find(res => res.isChoose === true)
      vm.form = {
        // ข้อมูลทั่วไป
        caseDate: new Date(),
        caseNumber: "",
        lawyer: (lawyerChoose ? lawyerChoose.value : null),
        borrower: null,
        contract: null,
        sureties: [],
        contractDate: null,
        curriculumName: "",
        firstMissedAppointmentDate: null,
        firstCollectionFeeLetterDate: null,
        sendCollectionFeeLetterCount: 0,
        // ทุนทรัพย์
        dateOfBalanceExtraction: null,
        principle: 0,
        interest: 0,
        penalty: 0,
        fee: 0,
        expenseDetailAmount: 0,
        collectionFee: 0,
        lawyerFee: 0, // ค่าทนาย หรือค่าใช้จ่ายในการดำเนินคดี (ที่ระบุไว้ในสัญญา)
        total: 0,
      }
      setContractOptions(null)
      setSuretyOptions(null)
    },
    submit: async function () {
      const vm = this
      const { createProsecution } = vm
      vm.$refs['form'].validate().then(success => {
        if (!success) {
          return
        }
        createProsecution({
          form: {
            // ข้อมูลทั่วไป
            caseDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.caseDate),
            caseNumber: vm.form.caseNumber,
            lawyer: {id: vm.form.lawyer || ''},
            borrower: {id: vm.form.borrower || ''},
            contract: {id: vm.form.contract || ''},
            sureties: vm.form.sureties.map((suretyId, index) => ({seq: index, surety: {
              id: suretyId
              }})),
            contractDate: vm.form.contractDate ? vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.contractDate) : null,
            curriculumName: vm.form.curriculumName,
            firstMissedAppointmentDate: vm.form.firstMissedAppointmentDate ? vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.firstMissedAppointmentDate) : null,
            firstCollectionFeeLetterDate: vm.form.firstCollectionFeeLetterDate ? vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.firstCollectionFeeLetterDate) : null,
            sendCollectionFeeLetterCount: parseInt(vm.form.sendCollectionFeeLetterCount),
            // ทรัพย์สิน
            dateOfBalanceExtraction: vm.form.dateOfBalanceExtraction ? vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.dateOfBalanceExtraction) : null,
            principle: parseFloat(vm.form.principle),
            interest: parseFloat(vm.form.interest),
            penalty: parseFloat(vm.form.penalty),
            fee: parseFloat(vm.form.fee),
            expenseDetailAmount: parseFloat(vm.form.expenseDetailAmount),
            collectionFee: parseFloat(vm.form.collectionFee),
            lawyerFee: parseFloat(vm.form.lawyerFee),
            total: 0,
          },
          vm,
          redirect: "/prosecution/userJob"
        })
      })
    },
    async onPressedActiveInfoModal(type) {
      if(type === 'caseNumber'){
        this.infoModal.text = '6701001 ปี ชุดที่ดำเนินคดี running'
      } else if(type === 'firstCollectionFeeLetterDate'){
        this.infoModal.text = 'วันที่ส่งหนังสือทวงถามครั้งแรก 30 วัน'
      } else if(type === 'contract'){
        this.infoModal.text = 'กรณีที่เป็นสัญญาปรับโครงสร้างหนี้ จะมีเครื่องหมาย * หลังชื่อ และหากดำเนินการส่งฝ่ายกฏหมายด้วยสัญญาดังกล่าวจะดำเนินการจั้งแต่ส่งเรื่องบังคับคดีได้เท่านั้น'
      } else if(type === 'sendCollectionFeeLetterCount'){
        this.infoModal.text = 'จำนวนครั้งที่โทรหรือไลน์ติดต่อลูกค้า'
      }else if(type === 'fee'){
        this.infoModal.text = 'รวมค่าติดตามทวงถาม และหนังสือทวงถาม'
      } else if(type === 'titleAsset'){
        this.infoModal.text = 'หนี้ค้างชำระสำหรับส่งฝ่ายกฎหมายเพื่อส่งหนังสือบอกกล่าวทวงถาม 60 วัน'
      } else if(type === 'dateOfBalanceExtraction'){
        this.infoModal.text = 'เลือกวันที่สรุปยอดหนี้ค้างชำระ โดยสามารถเลือกวันที่ล่าสุดได้เพียงวันที่คิดดอกเบี้ยล่าสุดเท่านั้น'
      }else if(type === 'expenseDetailAmount'){
        this.infoModal.text = 'ค่าใช้จ่ายอื่นๆ เช่น ค่าธรรมเนียมการทำสัญญา ค่าอากรแสตมป์ ค่าดำเนินการ ค่าใช้จ่ายอื่นตามคำสั่งศาล เป็นต้น'
      } else if(type === 'expenseAmountAfter'){
        this.infoModal.text = 'ยอดรวมในหัวข้อ "ค่าใช้จ่ายในการดำเนินคดี (สำหรับฝ่ายกฎหมาย)" ที่ศาลอนุมัติให้เรียกเก็บจากลูกค้าได้ <br>'
        this.infoModal.text += `1. ${this.$t('sections.prosecution.dataForm.courtFee')} <br>`
        this.infoModal.text += `2. ${this.$t('sections.prosecution.dataForm.documentFee')} <br>`
        this.infoModal.text += `3. ${this.$t('sections.prosecution.dataForm.sendOpponentFee')} <br>`
        this.infoModal.text += `4. ${this.$t('sections.prosecution.dataForm.sendEnforcementFee')} <br>`
      } else if(type === 'courtFeeReturn'){
        this.infoModal.text = 'ค่าธรรมเนียมศาล กรณีศาลสั่งคืนให้กับบริษัทนำไปหักลบกับค่าธรรมเนียมศาล'
      } else if(type === 'totalAsset'){
        this.infoModal.text = 'เพื่อออกหนังสือถวงถาม'
      }
      this.infoModal.active = true
    },
  },
  watch: {
    "form.borrower": async function (borrowerId) {
      const vm = this
      if(vm.created){
        vm.$vs.loading();
        const { getContractOptionsForProsecution, setContractOptions,  setSuretyOptions} = vm
        const borrower = vm.borrowerOptions.find(res => res.value === borrowerId)
        if(borrower){
          await getContractOptionsForProsecution({
            borrower: { id: borrowerId }
          })
        } else {
          await setContractOptions(null)
        }
        await setSuretyOptions(null)
        vm.form.contract = ""
        vm.form.sureties = []
        vm.form.contractDate = null
        vm.form.curriculumName = ""
        vm.form.firstMissedAppointmentDate = null
        vm.$vs.loading.close();
      }
    },
    "form.contract": async function (contractId) {
      const vm = this
      if(vm.created){
        vm.$vs.loading();
        const { getSuretyFilterOptionsForProsecution,  setSuretyOptions} = vm
        const contract = vm.contractOptions.find(res => res.id === contractId)
        if(contract){
          await getSuretyFilterOptionsForProsecution({
            contract: { id: contractId }
          });
          vm.form.contractDate = vm.$options.filters.convYYYYMMDDToDDMMYYYY(contract.contractDate)
          vm.form.curriculumName = contract.curriculumName;
          vm.form.firstMissedAppointmentDate = vm.$options.filters.convYYYYMMDDToDDMMYYYY(contract.firstMissedAppointmentDate)
        }else{
          await setSuretyOptions(null);
          vm.form.contractDate = null;
          vm.form.curriculumName = "";
          vm.form.firstMissedAppointmentDate = null;
        }
        vm.form.sureties = [];
        vm.$vs.loading.close();
      }
    },
    status: {
      handler(res){
        if(res.processing !== null){
          if(res.processing){
            this.$vs.loading();
          }else{
            this.$vs.loading.close();
          }
        }
        if(res.success !== null){
          this.$vs.notify({...res.success})
        }else if(res.error !== null){
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  }
}
</script>

<style scoped>
.vx-col {
  margin-bottom: 1rem; /* This is the equivalent of Bootstrap's mt-5 */
}
</style>
